import {theme} from '@logistics-frontend/blocks/lpc/theme'
import {css} from '@logistics-frontend/blocks/theme/css'

export const classes = {
  root: css`
    font-style: normal;
    font-weight: 500;
    font-size: 24px;
    line-height: 27px;
    letter-spacing: -0.01em;
    font-feature-settings: 'pnum' on, 'lnum' on;
    margin: ${theme.spacing(1.2, 0)};
  `,
}
